import { ApiTypes } from 'common';
import { Call } from '@src/services/api';
import { ApiHelper } from '@src/services/helpers/api';
import { Category } from '@adalong/schemas';
import { ANALYTICS_ACTIONS, ANALYTICS_CATEGORIES, trackAnalyticsEvent } from '@src/utils/analyticsTracking';

export const getProducts = async (
  params: ApiTypes.ParamsGetProducts,
): Promise<ApiTypes.ResGetProducts['products']> => {
  const res = await Call.get<ApiTypes.ResGetProducts, ApiTypes.ParamsGetProducts>(
    '/api/products',
    params,
    { cache: 'no-store' },
  );
  trackAnalyticsEvent(ANALYTICS_ACTIONS.productsLoaded, ANALYTICS_CATEGORIES.product);
  return res.products;
};

export const getSuggestions = async (
  params: ApiTypes.ParamsGetProductsSuggestions,
): Promise<ApiTypes.ResGetProductsSuggestions> => {
  const res = await Call.get<ApiTypes.ResGetProductsSuggestions, ApiTypes.ParamsGetProductsSuggestions>(
    '/api/products/suggestions',
    params,
  );
  return res;
};

export const getTaxonomy = (): Promise<Category> => Call.get('/api/catalog/taxonomy');

export const getProductGroups = async (
  params: ApiTypes.ParamsGetProductGroups,
): Promise<ApiTypes.ResGetProductGroups> => {
  const MAX_QUERYSTRING_LENGTH = 100;
  const qsLength = params ? ApiHelper.serializeToQS(params).length : 0;
  const shouldPost = qsLength > MAX_QUERYSTRING_LENGTH;

  const response = shouldPost
    ? Call.post<ApiTypes.ResGetProductGroups, ApiTypes.ParamsGetProductGroups>('/api/product-groups', params)
    : Call.get<ApiTypes.ResGetProductGroups, ApiTypes.ParamsGetProductGroups>('/api/product-groups', params);
  const res = await response;
  trackAnalyticsEvent(ANALYTICS_ACTIONS.productsLoaded, ANALYTICS_CATEGORIES.product);
  return res;
};

export const getAllProductGroups = async (): Promise<ApiTypes.ResGetAllProductGroups> => {
  const res = await Call.get('/api/product-groups', { size: 9999 });
  trackAnalyticsEvent(ANALYTICS_ACTIONS.productsLoaded, ANALYTICS_CATEGORIES.product);
  return res;
};

export const getProductsAvailablesLocalizations = async (): Promise<ApiTypes.ResGetLocalizationMappings> => {
  return Call.get<ApiTypes.ResGetLocalizationMappings >('/api/products/country-mappings');
}
